jQuery(document).ready(function ($) {
    var $predictiveSearch = $('.site-nav__icons .site-header__search-island.desktop');
    var $searchButton = $predictiveSearch.find('.btn-action-search');
    var $inputWrap = $predictiveSearch.find('.search__input-wrap');
    // Handle button click
    $predictiveSearch.on("click", function (event) {
        var $searchButton = $(this).find('.btn-action-search');
        if ($searchButton.attr("type") !== "submit") {
            event.preventDefault();
            $searchButton.attr("type", "submit");
            $inputWrap.addClass('show__form');
        }
    });

    //Handle clicks outside predictive search
    $(document).on("click", function (event) {
        if (!$predictiveSearch.is(event.target) && $predictiveSearch.has(event.target).length === 0) {
            $inputWrap.removeClass('show__form');
            $searchButton.attr("type", "button");
        }
    });

    var $dtElements = $('.wrapper__content--has-navigator dt');

    $dtElements.on("click", function () {
        var $this = $(this);
        var $dd = $this.next(); // Get the next sibling (dd element)

        // Toggle active class on the clicked dt
        $this.toggleClass('active');

        // Slide toggle the dd content
        $dd.stop().slideToggle(300); // Adjust the duration (300ms) as needed
    });

    var $menuBurger = $('.site-nav__desktop-menu');
    $menuBurger.on("click", function () {
        $('body').addClass('dialog__burger--showed');
        $('.dialog__burger--menu').addClass('fixed')
    })

    var $menuBurgerClose = $('.dialog__burger--menu .burger--close .icon');
    $menuBurgerClose.on("click", function () {
        $('body').removeClass('dialog__burger--showed');
        $('.dialog__burger--menu').removeClass('fixed')
    })

    $(window).resize(function () {
        var $centeredDiv = $('.dialog__burger--menu');

        if ($(window).height() > 1200 && $centeredDiv.length) {
            $centeredDiv.addClass('resize-match');
        } else {
            $centeredDiv.removeClass('resize-match');
        }
    });

    function checkResize() {
        var $centeredDiv = $('.dialog__burger--menu');

        if ($(window).height() > 1212 && $centeredDiv.length) {
            $centeredDiv.addClass('resize-match');
        } else {
            $centeredDiv.removeClass('resize-match');
        }
    }

    checkResize();

    $(window).resize(function () {
        checkResize();
    });

    var $elTableNavigator = $('.wrapper__content--has-navigator .page--content table');
    if ($elTableNavigator.length) {
        $elTableNavigator.each(function () {
            // Wrap each table with a div having class 'table-container'
            $(this).wrap('<div class="table-container"></div>');
        });
    }

    // 

});